import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Stripe } from '@stripe/stripe-js'

interface StripeProviderProps {
  children: React.ReactNode
  publishableKey: string
  onStripeLoaded?: (stripe: Stripe | null) => void
}

function StripeProvider ({children, publishableKey, onStripeLoaded}: StripeProviderProps) {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null)
  const [stripeInstance, setStripeInstance] = useState<Stripe | null>(null)

  useEffect(() => {
    if (publishableKey) {
      const promise = loadStripe(publishableKey)
      setStripePromise(promise)
      
      promise.then((stripe) => {
        setStripeInstance(stripe)
        if (onStripeLoaded) {
          onStripeLoaded(stripe)
        }
      }).catch((error) => {
        console.error('Failed to load Stripe:', error)
        if (onStripeLoaded) {
          onStripeLoaded(null)
        }
      })
    }
  }, [publishableKey, onStripeLoaded])

  if (!stripePromise) {
    return (
      <div className="stripe-loading">
        <div className="loading-spinner">
          <i className="cs-icon icon-spinner"></i>
          Loading payment system...
        </div>
      </div>
    )
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  )
}

export default StripeProvider 